export default __webpack_public_path__ + "static/media/overflow.abc79b50.svg";